import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { BASE_API_URL } from '../../../../utils/constants';
import { myFirebaseAuth } from '../../../../firebase/config';
import { CollectionSequenceBuyerProgress } from '@dill/dill-shared';

// Same shape as useCollectionSequenceBuyerProgress, but scoped to ONE sequence and across every
// status (not just ACTIVE/PAUSED) - backs the sequence detail page's enrollment table and
// per-step chart, where a buyer who's already finished or unenrolled still needs to show up.
export const useCollectionSequenceBuyerProgressForSequence = (
  sequenceId: string,
  supplierId: string
) => {
  const [progressByBuyerId, setProgressByBuyerId] = useState<
    Record<string, CollectionSequenceBuyerProgress>
  >({});
  const [isLoading, setIsLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!supplierId || !sequenceId) return;
    setIsLoading(true);
    try {
      const token = await myFirebaseAuth.currentUser?.getIdToken();
      if (!token) return;
      const response = await axios.get(
        `${BASE_API_URL}/suppliers/${supplierId}/collectionSequences/${sequenceId}/getCollectionSequenceBuyerProgress`,
        { headers: { Authorization: 'Bearer ' + token } }
      );
      const data: Record<string, CollectionSequenceBuyerProgress> = response.data?.success
        ? response.data.data ?? {}
        : {};
      setProgressByBuyerId(data);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }, [supplierId, sequenceId]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { progressByBuyerId, isLoading, refresh };
};

export default useCollectionSequenceBuyerProgressForSequence;
